export default {
  firebase: {
    apiKey: 'AIzaSyDC3nUUjegTnX0CpC4aP3iAGcTkLD6IPcQ',
    authDomain: 'zeropad.firebaseapp.com',
    databaseURL: 'https://zeropad.firebaseio.com',
    storageBucket: 'project-8390866447668253974.appspot.com',
    messagingSenderId: '126446194048',
  },
}



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/